// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".svg path[data-v-4e5790fa] {\n  fill: red !important;\n}\n.svg path:hover path[data-v-4e5790fa] {\n  fill: white !important;\n}", ""]);
// Exports
module.exports = exports;
